export const UPDATE_USER_DATA = "UPDATE_USER_DATA";

export const UPDATE_BOOK_STORAGE_POPUP_STATE =
  "UPDATE_BOOK_STORAGE_POPUP_STATE";
